   console.log("INT BUNDLES");
  /* ----------------------------
     1. JSON DATA
  ---------------------------- */
  const BUNDLE_JSON = {
    
    "10215656489144": {
      ref:"Limited Edition Animal Bundle",
      type:"bundle",
      bundles: {
        single: {
          name:"single pack",
          label:"1 bundle",
          off:"10% off",
          qty: 1,
          compare_at: 24.00,
          price: 21.60,
          subscription_price: 19.44
        },
        family: {
          name:"family pack",
          label:"2 bundles",
          off:"15% off",
          qty: 2,
          compare_at: 48.00,
          price: 41.04,
          subscription_price: 36.94,
          subscription_discount: 23
        },
        large: {
          name:"large family pack",
          label:"3 bundles",
          off:"20% off",
          qty: 3,
          compare_at: 72.00,
          price: 58.32,
          subscription_price: 52.50
        }
      }
    },
    "10119247036600": {
      ref:"Animal bundle",
      type:"bundle",
      bundles: {
        single: {
          name:"single pack",
          label:"1 bundle",
          off:"10% off",
          qty: 1,
          compare_at: 18.00,
          price: 16.00,
          subscription_price: 14.40
        },
        family: {
          name:"family pack",
          label:"2 bundles",
          off:"15% off",
          //off:"21% off",
          qty: 2,
          compare_at: 36.00,
          price: 30.4,
          subscription_price: 27.36
        },
        large: {
          name:"large family pack",
          label:"3 bundles",
          off:"20% off",
          qty: 3,
          compare_at: 54.00,
          price: 43.2,
          subscription_price: 38.88,
        }
      }
    },
    "10429313384632": {
      ref:"Animal bundle",
      type:"bundle",
      bundles: {
        single: {
          name:"single pack",
          label:"1 bundle",
          off:"10% off",
          qty: 1,
          compare_at: 36.00,
          price: 32.00,
          subscription_price: 28.80
        },
        family: {
          name:"family pack",
          label:"2 bundles",
          off:"15% off",
          //off:"21% off",
          qty: 2,
          compare_at: 72.00,
          price: 60.8,
          subscription_price: 54.72
        },
        large: {
          name:"large family pack",
          label:"3 bundles",
          off:"20% off",
          qty: 3,
          compare_at: 108.00,
          price: 86.4,
          subscription_price: 77.76,
        }
      }
    },
    "10119227801784": {
      ref:"Jelly bundle",
      type:"bundle",
      bundles: {
        single: {
          name:"single pack",
          label:"1 bundle",
          off:"10% off",
          qty: 1,
          compare_at: 28.00,
          price: 25.00,
          subscription_price: 22.50
        },
        family: {
          name:"family pack",
          label:"2 bundles",
          off:"15% off",
          //off:"19% off",
          qty: 2,
          compare_at: 56.00,
          price: 47.50,
          subscription_price: 42.76
        },
        large: {
          name:"large family pack",
          label:"3 bundles",
          off:"20% off",
          qty: 3,
          compare_at: 84.00,
          price: 67.50,
          subscription_price: 60.75
        }
      }
    },
    "10118820430008": {
      ref:"Intro bundle",
      type:"bundle",
      bundles: {
        single: {
          name:"single pack",
          label:"1 bundle",
          off:"10% off",
          //off:"19% off",
          qty: 1,
          compare_at: 32.00,
          price: 29.00,
          subscription_price: 26.10
        },
        family: {
          name:"family pack",
          label:"2 bundles",
          off:"15% off",
          qty: 2,
          compare_at: 64.00,
          price: 55.10,
          subscription_price: 49.60
        },
        large: {
          name:"large family pack",
          label:"3 bundles",
          off:"20% off",
          qty: 3,
          compare_at: 96.00,
          price: 78.30,
          subscription_price: 70.47
        }
      }
    },
    "10109402742968": {
      ref:"Animal mask unicorn",
      type:"single",
      bundles: {
        single: {
          name:"single pack",
          label:"1 mask",
          off:"",
          qty: 1,
          compare_at: 5.99,
          price: 5.99,
          subscription_price: 5.39
        },
        family: {
          name:"family pack",
          label:"5 masks",
          off:"10% off",
          qty: 5,
          compare_at: 29.95,
          price: 27.0,
          subscription_price: 24.25
        },
        large: {
          name:"large family pack",
          label:"10 masks",
          off:"15% off",
          qty: 10,
          compare_at: 59.9,
          price: 51.0,
          subscription_price: 45.82
        }
      }
    },

    "10109401956536": {
      type:"single",
      ref:"Animal mask puppy",
      bundles: {
        single: {
          name:"single pack",
          label:"1 mask",
          off:"",
          qty: 1,
          compare_at: 5.99,
          price: 5.99,
          subscription_price: 5.39
        },
        family: {
          name:"family pack",
          label:"5 masks",
          off:"10% off",
          qty: 5,
          compare_at: 29.95,
          price: 27.0,
          subscription_price: 24.25
        },
        large: {
          name:"large family pack",
          label:"10 masks",
          off:"15% off",
          qty: 10,
          compare_at: 59.9,
          price: 51.0,
          subscription_price: 45.82
        }
      }
    },

    "10060869992632": {
      ref:"Animal mask panda",
      type:"single",
      bundles: {
        single: {
          name:"single pack",
          label:"1 mask",
          off:"",
          qty: 1,
          compare_at: 5.99,
          price: 5.99,
          subscription_price: 5.39
        },
        family: {
          name:"family pack",
          label:"5 masks",
          off:"10% off",
          qty: 5,
          compare_at: 29.95,
          price: 27.0,
          subscription_price: 24.25
        },
        large: {
          name:"large family pack",
          label:"10 masks",
          off:"15% off",
          qty: 10,
          compare_at: 59.9,
          price: 51.0,
          subscription_price: 45.82
        }
      }
    },

    "10109389340856": {
      ref:"Aftersun",
      type:"single",
      bundles: {
        single: {
          name:"single pack",
          label:"1 mask",
          off:"",
          qty: 1,
          compare_at: 6.99,
          price: 6.99,
          subscription_price: 6.29
        },
        family: {
          name:"family pack",
          label:"5 masks",
          off:"10% off",
          qty: 5,
          compare_at: 34.95,
          price: 31.5,
          subscription_price: 28.30
        },
        large: {
          name:"large family pack",
          label:"10 masks",
          off:"15% off",
          qty: 10,
          compare_at: 69.9,
          price: 59.5,
          subscription_price: 53.47
        }
      }
    },

    "10060640157880": {
      ref:"Hydrating hydrogel",
      type:"single",
      bundles: {
        single: {
          name:"single pack",
          label:"1 mask",
          off:"",
          qty: 1,
          compare_at: 6.99,
          price: 6.99,
          subscription_price: 6.29
        },
        family: {
          name:"family pack",
          label:"5 masks",
          off:"10% off",
          qty: 5,
          compare_at: 34.95,
          price: 31.5,
          subscription_price: 28.30
        },
        large: {
          name:"large family pack",
          label:"10 masks",
          off:"15% off",
          qty: 10,
          compare_at: 69.9,
          price: 59.5,
          subscription_price: 53.47
        }
      }
    },

    "10215618904248": {
      ref:"Gentle Facial Sheet Mask – Bunny",
      type:"single",
      bundles: {
        single: {
          name:"single pack",
          label:"1 mask",
          off:"",
          qty: 1,
          compare_at: 5.99,
          price: 5.99,
          subscription_price: 5.39
        },
        family: {
          name:"family pack",
          label:"5 masks",
          off:"10% off",
          qty: 5,
          compare_at: 29.95,
          price: 27.0,
          subscription_price: 24.25
        },
        large: {
          name:"large family pack",
          label:"10 masks",
          off:"15% off",
          qty: 10,
          compare_at: 59.9,
          price: 51.0,
          subscription_price: 45.82
        }
      }
    }
  };

  console.log("[Standalone Bundle Script] Init");

  /* ----------------------------
     1. PRODUCT ID + JSON
  ---------------------------- */
  const productId = document.querySelector('input[name="product-id"]')?.value;
  if (productId && BUNDLE_JSON[productId]){

  const productData = BUNDLE_JSON[productId];

  /* ----------------------------
     2. DOM TARGETS
  ---------------------------- */

  /* ----------------------------
     2. Wait for drawer + qty
  ---------------------------- */
  const waitForDrawer = (cb) => {
    const iv = setInterval(() => {
      const drawer = document.querySelector(".mobile-drawer");
      const qtyWrapper = document.querySelector(".drawer-qty");
      if (drawer && qtyWrapper) {
        clearInterval(iv);
        cb(drawer, qtyWrapper);
      }
    }, 150);
  };

  waitForDrawer((drawer, qtyWrapper) => {
        console.log("[Standalone Bundle Script] Drawer found");
        const mainForm = Array.from(document.querySelectorAll("form[action='/cart/add']")).find(form => form.offsetParent !== null);
        const qtyInput = mainForm.querySelector('input[name="quantity"]');
        const priceDisplay = drawer?.querySelector(".drawer-price");

        if (!qtyInput || !qtyWrapper || !priceDisplay) return;

        const buybtn = drawer?.querySelector(".ghost-btn.onetime");
        //buybtn.textContent = "add to cart";

        /* ----------------------------
            3. STATE
        ---------------------------- */
        let activeBundleKey = "single";
        let activeMode = "onetime";

        /* ----------------------------
            4. INJECT CSS (JS ONLY)
        ---------------------------- */
        const style = document.createElement("style");
        style.innerHTML = `
            /*
            .ghost-btn.subscribe {
              display:none;
            }
            */
            
            .mobile-drawer.collapsed .drawer-qty-bundle{
                display:none;
            }
            .drawer-qty-bundle {
                display:flex;
                justify-content:space-between;
                gap:10px;
                margin-top:10px;
            }
            .drawer-qty-bundle .bundle {
                display:flex;
                flex-direction:column;
                align-items:center;
                flex-grow: 1;
                gap:3px;
                cursor:pointer;
            }
            .drawer-qty-bundle .bundle-btn {
                display:flex;
                flex-direction:column;
                align-items:center;
                width:100%;
                padding:10px 15px;
                border-radius:9px;
                border:0.75px solid #333430;
                font-size:12px;
                font-weight:500;
                text-transform:lowercase;
                color:#333430;
                text-align: center;
            }
            .drawer-qty-bundle .bundle-btn span {
                color:rgba(51,52,48,.6);
                font-size:11px;
            }
            .drawer-qty-bundle .bundle.active .bundle-btn {
                background:#E2DCFF;
                border-color:#E2DCFF;
            }
            .drawer-qty-bundle .bundle-label {
                padding:5px 8px;
                border-radius:25px;
                background:#EFFE8D;
                font-size:12px;
                font-weight:500;
                text-transform:lowercase;
            }
        `;
        document.head.appendChild(style);

        /* ----------------------------
            5. HIDE ORIGINAL QTY
        ---------------------------- */
        qtyWrapper.style.display = "none";

        /* ----------------------------
            6. BUILD BUNDLE HTML FROM JSON
        ---------------------------- */
        const bundleContainer = document.createElement("div");
        bundleContainer.className = "drawer-qty-bundle";

        Object.entries(productData.bundles).forEach(([key, b], index) => {
            bundleContainer.innerHTML += `
            <div class="bundle ${index === 0 ? "active" : ""}" 
                data-key="${key}" 
                data-qty="${b.qty}"
                data-price="${b.compare_at}"
                data-subscription-price="${b.subscription_price}"
            >
                <div class="bundle-btn">
                ${b.name}
                <span>${b.label}</span>
                </div>
                <div class="bundle-label"><span>${b.off}</span></div>
            </div>
            `;
        });

        qtyWrapper.insertAdjacentElement("afterend", bundleContainer);

        const bundles = bundleContainer.querySelectorAll(".bundle");

        /* ----------------------------
            7. HELPERS
        ---------------------------- */
        function updateQty(qty) {
            qtyInput.value = qty;
            qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        function renderPrice() {
            const bundle = productData.bundles[activeBundleKey];
            if (!bundle) return;

            const finalPrice =
            activeMode === "subscribe"
                ? bundle.subscription_price
                : bundle.price;

            priceDisplay.innerHTML = `
            <div class="drawer-price-inner">
                ${bundle.compare_at!=finalPrice ? 
                    `<span style="text-decoration:line-through;opacity:.5">
                        $${bundle.compare_at.toFixed(2)}
                        </span>` : ``
                }
                <span style="margin-left:8px;font-weight:600">
                $${finalPrice.toFixed(2)}
                </span>
            </div>
            `;
        }

        /* ----------------------------
            8. BUNDLE CLICK HANDLING
        ---------------------------- */
        bundles.forEach(bundleEl => {
            bundleEl.addEventListener("click", () => {
            const key = bundleEl.dataset.key;
            const bundle = productData.bundles[key];
            if (!bundle) return;

            activeBundleKey = key;

            updateQty(bundle.qty);

            bundles.forEach(b => b.classList.remove("active"));
            bundleEl.classList.add("active");

            renderPrice();
            });
        });

        /* ----------------------------
            9. PATCH handleBuyClick (STANDALONE)
        ---------------------------- */
        const waitForModeButtons = setInterval(() => {
            const onetimeBtn = drawer.querySelector(".ghost-btn.onetime");
            const subscribeBtn = drawer.querySelector(".ghost-btn.subscribe");

            if (!onetimeBtn || !subscribeBtn) return;

            clearInterval(waitForModeButtons);

            onetimeBtn.addEventListener("click", () => {
                activeMode = "onetime";
                renderPrice();
                console.log("[Mode] One-time");
            });

            subscribeBtn.addEventListener("click", () => {
                activeMode = "subscribe";
                renderPrice();
                console.log("[Mode] Subscribe");
            });
        }, 150);

        /* ----------------------------
            10. AUTO-SELECT BY EXISTING QTY
        ---------------------------- */
        const initialQty = parseInt(qtyInput.value, 10);
        Object.entries(productData.bundles).forEach(([key, b]) => {
            if (b.qty === initialQty) {
            activeBundleKey = key;
            }
        });

        renderPrice();

        window.dispatchEvent(new CustomEvent('bundle:ready'));
    });













   
    function waitForLoopWidget(callback) {
        const checkExist = setInterval(() => {
        const loopContainer = document.querySelector(".loop-widget-container");
        const hasOptions = loopContainer && loopContainer.querySelectorAll(".loop-widget-purchase-option").length > 0;
        if (hasOptions) {
            clearInterval(checkExist);
            callback(loopContainer);
        }
        }, 250);
    }

    waitForLoopWidget(loopContainer => {

    const oneTimeOption = loopContainer.querySelector(".loop-widget-purchase-option-onetime");
    const subOption = loopContainer.querySelector('[data-loop-widget-selling-plan-group]');
    
    // Hide the sub options remove it after testing
    /*
    const selectOption = el => {
      if (el && !el.classList.contains("loop-widget-purchase-option-selected")) el.click();
    };

    setTimeout(() => {
      selectOption(oneTimeOption);
      const purchaseoptions = loopContainer.querySelector(".loop-widget-purchase-options-container");
      purchaseoptions.style.display = "none"
      const addtocartBtn = document.querySelector(".product-buy-buttons--cta-text");
      if (addtocartBtn) addtocartBtn.textContent = "add to cart";
    }, 200);
    */
    //Testing block ends

    (function initDesktopBundles() {
        if (window.innerWidth < 768) return; // desktop only

        console.log("[Desktop Bundle Script] Init");

        const productId = document.querySelector('input[name="product-id"]')?.value;
        if (!productId || !BUNDLE_JSON[productId]) return;

        const productData = BUNDLE_JSON[productId];

        /* ----------------------------
            DESKTOP TARGETS
        ---------------------------- */
        const qtyWrapper = document.querySelector(".qty-wrapper");
        const qtyInput = document.querySelector(
            '.quantity-selector--input[name="quantity"]'
        );

        const priceWrapper = document.querySelector(".product-price--wrapper");
        const priceOriginal = priceWrapper?.querySelector(".product-price--original");
        const priceCompare = priceWrapper?.querySelector(".product-price--compare");

        if (!qtyWrapper || !qtyInput || !priceWrapper) return;

        /* ----------------------------
            STATE
        ---------------------------- */
        let activeBundleKey = "single";
        let activeMode = "onetime";

        /* ----------------------------
            DESKTOP CSS (same look as mobile)
        ---------------------------- */
        if (!document.getElementById("desktop-bundle-style")) {
            const style = document.createElement("style");
            style.id = "desktop-bundle-style";
            style.innerHTML = `

            .product-form--block[data-block-type="buy-buttons-with-qty"] {
                margin-top:0!important;
            }

            .buy-button-with-qty {
                flex-direction: column;
                gap:8px;
            }

            .buy-button-with-qty .button-wrapper {
                width:100%;
            }

            .desktop-qty-bundle {
                display:flex;
                justify-content:space-between;
                gap:10px;
                margin-top:10px;
            }
            .desktop-qty-bundle .bundle {
                display:flex;
                flex-direction:column;
                align-items:center;
                flex-grow: 1;
                gap:3px;
                cursor:pointer;
            }
            .desktop-qty-bundle .bundle-btn {
                display:flex;
                flex-direction:column;
                align-items:center;
                width:100%;
                padding:10px 15px;
                border-radius:9px;
                border:0.75px solid #333430;
                font-size:12px;
                font-weight:500;
                text-transform:lowercase;
                color:#333430;
                text-align:center;
            }
            .desktop-qty-bundle .bundle-btn span {
                color:rgba(51,52,48,.6);
                font-size:11px;
            }
            .desktop-qty-bundle .bundle.active .bundle-btn {
                background:#E2DCFF;
                border-color:#E2DCFF;
            }
            .desktop-qty-bundle .bundle-label {
                padding:5px 8px;
                border-radius:25px;
                background:#EFFE8D;
                font-size:12px;
                font-weight:500;
                text-transform:lowercase;
            }

            .product-price--compare {
                font-size:14px;
            }

            .qty-wrapper {
                height: 0px;
                opacity: 0;
                position: absolute;
                overflow: hidden;
            }
            `;
            document.head.appendChild(style);
        }


        /* ----------------------------
            BUILD DESKTOP BUNDLE UI
        ---------------------------- */
        const bundleContainer = document.createElement("div");
        bundleContainer.className = "desktop-qty-bundle";

        Object.entries(productData.bundles).forEach(([key, b], index) => {
            bundleContainer.innerHTML += `
            <div class="bundle ${index === 0 ? "active" : ""}" 
              data-key="${key}"
              data-price="${b.compare_at}"
              data-subscription-price="${b.subscription_price}"
            >
                <div class="bundle-btn">
                ${b.name}
                <span>${b.label}</span>
                </div>
                <div class="bundle-label"><span>${b.off}</span></div>
            </div>
            `;
        });

        qtyWrapper.insertAdjacentElement("afterend", bundleContainer);
        const bundles = bundleContainer.querySelectorAll(".bundle");

        /* ----------------------------
            HELPERS (MATCH MOBILE)
        ---------------------------- */
        function updateQty(qty) {
            qtyInput.value = qty;
            qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        function renderPrice() {
            const loop_ontime_price = oneTimeOption.querySelector(".loop-widget-purchase-option-price");
            const loop_ontime_compare_price = oneTimeOption.querySelector(".loop-widget-purchase-option-compare-at-price");

            const loop_sub_price = subOption.querySelector(".loop-widget-purchase-option-price");
            const loop_sub_compare_price = subOption.querySelector(".loop-widget-purchase-option-compare-at-price");

            const bundle = productData.bundles[activeBundleKey];
            if (!bundle) return;

            const finalPrice =
            activeMode === "subscribe"
                ? bundle.subscription_price
                : bundle.price;

            priceOriginal.innerHTML = `$${finalPrice.toFixed(2)}`;
            loop_ontime_price.innerHTML = `$${bundle.price.toFixed(2)}`;
            loop_ontime_compare_price.innerHTML = `$${bundle.compare_at.toFixed(2)}`;

            loop_sub_price.innerHTML = `$${bundle.subscription_price.toFixed(2)}`;
            loop_sub_compare_price.innerHTML = `$${bundle.compare_at.toFixed(2)}`;


            if (bundle.compare_at !== finalPrice) {
                priceCompare.innerHTML = `$${bundle.compare_at.toFixed(2)}`;
                priceCompare.style.display = "block";

                //loop container price updates
                loop_ontime_compare_price.classList.remove("loop-display-none");

            } else {
                priceCompare.style.display = "none";
                loop_ontime_compare_price.classList.add("loop-display-none");
            }
        }

        /* ----------------------------
            BUNDLE CLICK
        ---------------------------- */
        bundles.forEach(bundleEl => {
            bundleEl.addEventListener("click", () => {
            const key = bundleEl.dataset.key;
            const bundle = productData.bundles[key];
            if (!bundle) return;

            activeBundleKey = key;
            updateQty(bundle.qty);

            bundles.forEach(b => b.classList.remove("active"));
            bundleEl.classList.add("active");

            renderPrice();
            });
        });

        /* ----------------------------
            MODE DETECTION (SAME BUTTONS)
        ---------------------------- */
         oneTimeOption.addEventListener("click", () => {
            setTimeout(() => {
                activeMode = "onetime";
                renderPrice();
                console.log("[Mode] One-time");
            }, 100 );
        });

        subOption.addEventListener("click", () => {
            setTimeout(() => {
                activeMode = "subscribe";
                renderPrice();
                console.log("[Mode] Subscribe");
            }, 100);
        });

        /* ----------------------------
            AUTO-SELECT BY EXISTING QTY
        ---------------------------- */
        function selectBundleByQty(qty) {
            Object.entries(productData.bundles).forEach(([key, b]) => {
                if (b.qty === qty) {
                activeBundleKey = key;

                // update active UI
                document.querySelectorAll(".bundle").forEach(el =>
                    el.classList.remove("active")
                );
                document
                    .querySelector(`.bundle[data-key="${key}"]`)
                    ?.classList.add("active");
                }
            });

            renderPrice();
        }


        selectBundleByQty(parseInt(qtyInput.value, 10));
        qtyInput.addEventListener("change", () => {
            const qty = parseInt(qtyInput.value, 10);
            if (!qty) return;

            selectBundleByQty(qty);
        });

        renderPrice();
    })();

    window.dispatchEvent(new CustomEvent('bundle:ready'));
    });

}


//update labels 2nd script - to do 1.join both script together, 2.make price dynamic from shopify we wont depend upon json

(function () {
  let isUpdating = false;

  const SELECTORS = {
    activeBundle: '.bundle.active',

    desktopBundleLabels: '.desktop-qty-bundle .bundle-label',
    mobileBundleLabels: '.drawer-qty-bundle .bundle-label',

    desktopSubscription:
      '[data-loop-widget-selling-plan-group].loop-widget-purchase-option-selected',

    mobileSubscription:
      '.ghost-btn.subscribe.active',

    desktopLabel:
      '[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-label',

    mobileLabel:
      '.drawer-actions .ghost-btn.subscribe',

    desktopDescItems:
      '[data-loop-widget-selling-plan-group] .loop-desc li',

    mobileDescItems:
      '.drawer-features .loop-desc li',

    quantityInput:
      '.quantity-selector--input',

    bundleContainer:
      '.desktop-qty-bundle',

    purchaseOption:
      '.loop-widget-purchase-option',
  };

  function calculateDiscount(price, subPrice) {
    if (!price || !subPrice) return 0;
    return Math.round(((price - subPrice) / price) * 100);
  }

  function setText(el, text) {
    if (el && el.textContent !== text) {
      el.textContent = text;
    }
  }

  function updateBundleLabels(selector, isSubscriptionSelected) {
    document.querySelectorAll(selector).forEach(label => {
      const bundle = label.closest('.bundle');
      if (!bundle) return;

      if (!label.dataset.originalText) {
        label.dataset.originalText = label.textContent;
      }

      const discount = calculateDiscount(
        parseFloat(bundle.dataset.price),
        parseFloat(bundle.dataset.subscriptionPrice)
      );

      setText(
        label,
        isSubscriptionSelected
          ? `${discount}% off`
          : label.dataset.originalText
      );
    });
  }

  function updateDescription(selector, discount) {
    const targetLi = [...document.querySelectorAll(selector)].find(li =>
      li.textContent.toLowerCase().includes('% off')
    );

    if (targetLi) {
      setText(
        targetLi,
        `save ${discount}% off every month`
      );
    }
  }

  function updateUI() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const activeBundle = document.querySelector(SELECTORS.activeBundle);

      if (!activeBundle) return;

      const discount = calculateDiscount(
        parseFloat(activeBundle.dataset.price),
        parseFloat(activeBundle.dataset.subscriptionPrice)
      );

      const isDesktopSubscriptionSelected =
        !!document.querySelector(SELECTORS.desktopSubscription);

      const isMobileSubscriptionSelected =
        !!document.querySelector(SELECTORS.mobileSubscription);

      // Dynamic bundle labels
      updateBundleLabels(
        SELECTORS.desktopBundleLabels,
        isDesktopSubscriptionSelected
      );

      updateBundleLabels(
        SELECTORS.mobileBundleLabels,
        isMobileSubscriptionSelected
      );

      // Main labels
      setText(
        document.querySelector(SELECTORS.desktopLabel),
        `subscribe • save ${discount}%`
      );

      setText(
        document.querySelector(SELECTORS.mobileLabel),
        `subscribe • save ${discount}%`
      );

      // Descriptions
      updateDescription(
        SELECTORS.desktopDescItems,
        discount
      );

      updateDescription(
        SELECTORS.mobileDescItems,
        discount
      );

    } finally {
      isUpdating = false;
    }
  }

  function init() {
    setTimeout(updateUI, 50);

    const qtyInput = document.querySelector(SELECTORS.quantityInput);

    if (qtyInput) {
      qtyInput.addEventListener('input', updateUI);
      qtyInput.addEventListener('change', updateUI);
    }

    document.addEventListener('click', function (e) {
      if (
        e.target.closest('.bundle') ||
        e.target.closest(SELECTORS.purchaseOption) ||
        e.target.closest('.ghost-btn')
      ) {
        setTimeout(updateUI, 50);
      }
    });

    const target = document.querySelector(SELECTORS.bundleContainer);

    if (target) {
      const observer = new MutationObserver(updateUI);

      observer.observe(target, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class'],
      });
    }
  }

  window.addEventListener('bundle:ready', init);
  window.addEventListener('bundle:update', updateUI);
})();


/* Stand alone discount % updater */
(function updateSubscriptionDiscountForNonBundleProducts() {

  function init() {

    // =====================================================
    // PRODUCT ID
    // =====================================================

    const productId = document.querySelector(
      'input[name="product-id"]'
    )?.value;


    // =====================================================
    // IGNORE PRODUCTS ALREADY HANDLED BY BUNDLE_JSON
    // =====================================================

    if (
      typeof BUNDLE_JSON !== "undefined" &&
      productId &&
      BUNDLE_JSON[productId]
    ) {
      return;
    }


    // =====================================================
    // PRODUCT DATA CACHE
    // =====================================================

    let productData = null;
    let productDataPromise = null;


    // =====================================================
    // GET PRODUCT HANDLE
    // =====================================================

    function getProductHandle() {

      const match = window.location.pathname.match(
        /\/products\/([^\/]+)/
      );

      return match ? match[1] : null;
    }


    // =====================================================
    // GET SHOPIFY PRODUCT JSON
    // =====================================================

    async function getProductData() {

      // Already loaded
      if (productData) {
        return productData;
      }

      // Already loading
      if (productDataPromise) {
        return productDataPromise;
      }

      const productHandle = getProductHandle();

      if (!productHandle) {
        return null;
      }

      productDataPromise = fetch(
        `/products/${productHandle}.js`
      )
        .then(function(response) {

          if (!response.ok) {
            throw new Error(
              `Product request failed: ${response.status}`
            );
          }

          return response.json();

        })
        .then(function(data) {

          productData = data;

          return data;

        })
        .catch(function(error) {

          console.error(
            "[Subscription Discount] Failed to load Shopify product",
            error
          );

          return null;

        });

      return productDataPromise;
    }


    // =====================================================
    // GET CURRENT VARIANT ID
    // =====================================================

    function getCurrentVariantId() {

      const variantInput = document.querySelector(
        'form[action*="/cart/add"] input[name="id"]'
      );

      if (variantInput?.value) {
        return String(variantInput.value);
      }

      const idInput = document.querySelector(
        'input[name="id"]'
      );

      if (idInput?.value) {
        return String(idInput.value);
      }

      return null;
    }


    // =====================================================
    // GET ORIGINAL SHOPIFY COMPARE-AT PRICE
    // =====================================================

    async function getProductCompareAtPrice() {

      const product = await getProductData();

      if (!product) {
        return null;
      }

      const variantId = getCurrentVariantId();

      if (!variantId) {
        return null;
      }

      const variant = product.variants.find(
        function(variant) {
          return String(variant.id) === String(variantId);
        }
      );

      if (!variant) {
        return null;
      }

      if (!variant.compare_at_price) {
        return null;
      }

      // Shopify product JSON prices are in cents
      return Number(variant.compare_at_price) / 100;
    }


    // =====================================================
    // GET LOOP SUBSCRIPTION PRICE
    // =====================================================

    function getLoopSubscriptionPrice() {

      const loopContainer = document.querySelector(
        ".loop-widget-container"
      );

      if (!loopContainer) {
        return null;
      }

      const subscriptionOption =
        loopContainer.querySelector(
          '[data-loop-widget-selling-plan-group]'
        );

      if (!subscriptionOption) {
        return null;
      }

      const priceElement =
        subscriptionOption.querySelector(
          ".loop-widget-purchase-option-price"
        );

      if (!priceElement) {
        return null;
      }

      const priceText =
        priceElement.textContent || "";

      const price =
        parseFloat(
          priceText.replace(/[^0-9.]/g, "")
        );

      if (!Number.isFinite(price)) {
        return null;
      }

      return price;
    }


    // =====================================================
    // CALCULATE DISCOUNT
    // =====================================================

    function calculateDiscount(
      compareAtPrice,
      subscriptionPrice
    ) {

      if (
        !Number.isFinite(compareAtPrice) ||
        !Number.isFinite(subscriptionPrice) ||
        compareAtPrice <= 0
      ) {
        return null;
      }

      const discount =
        (
          (compareAtPrice - subscriptionPrice) /
          compareAtPrice
        ) * 100;

      return Number(
        discount.toFixed(2)
      );
    }


    // =====================================================
    // FORMAT PRICE
    // =====================================================

    function formatPrice(
      element,
      price
    ) {

      if (!element) {
        return;
      }

      const currentText =
        element.textContent.trim();

      /*
       * Preserve whatever currency symbol Loop
       * is already using.
       *
       * Example:
       * $45.00
       * €45.00
       * £45.00
       */

      const match =
        currentText.match(
          /^([^\d]*)([\d,.]+)(.*)$/
        );

      if (!match) {
        return;
      }

      const prefix = match[1];
      const suffix = match[3];

      const formattedPrice =
        Number(price).toFixed(2);

      const newText =
        `${prefix}${formattedPrice}${suffix}`;

      if (
        currentText !== newText
      ) {
        element.textContent = newText;
      }
    }


    // =====================================================
    // UPDATE MOBILE DESCRIPTION
    // =====================================================

    function updateMobileDescription(
      discount
    ) {

      const newText =
        `save ${discount}% off every month`;


      // Primary selector from your mobile drawer
      const mobileItems =
        document.querySelectorAll(
          ".drawer-features li"
        );


      mobileItems.forEach(function(li) {

        const currentText =
          li.textContent
            .trim()
            .toLowerCase();

        /*
         * Only update the subscription discount
         * line.
         *
         * Examples matched:
         *
         * save 10% off every month
         * save an additional 10% off every month
         */

        if (
          currentText.includes("% off") &&
          currentText.includes("every month")
        ) {

          if (
            li.textContent.trim() !== newText
          ) {
            li.textContent = newText;
          }

        }

      });
    }


    // =====================================================
    // UPDATE DESKTOP DESCRIPTION
    // =====================================================

    function updateDesktopDescription(
      subscriptionOption,
      discount
    ) {

      const newText =
        `save an additional ${discount}% off every month`;


      subscriptionOption
        .querySelectorAll(".loop-desc li")
        .forEach(function(li) {

          const currentText =
            li.textContent
              .trim()
              .toLowerCase();

          if (
            currentText.includes("% off") &&
            currentText.includes("every month")
          ) {

            if (
              li.textContent.trim() !== newText
            ) {
              li.textContent = newText;
            }

          }

        });
    }


    // =====================================================
    // UPDATE SUBSCRIPTION UI
    // =====================================================

    let isUpdating = false;

    async function updateSubscriptionDiscount() {

      // Prevent overlapping calls
      if (isUpdating) {
        return;
      }

      isUpdating = true;

      try {

        // -----------------------------------------------
        // Find Loop
        // -----------------------------------------------

        const loopContainer =
          document.querySelector(
            ".loop-widget-container"
          );

        if (!loopContainer) {
          return;
        }


        // -----------------------------------------------
        // Find subscription option
        // -----------------------------------------------

        const subscriptionOption =
          loopContainer.querySelector(
            '[data-loop-widget-selling-plan-group]'
          );

        if (!subscriptionOption) {
          return;
        }


        // -----------------------------------------------
        // Get Loop subscription price
        // -----------------------------------------------

        const subscriptionPrice =
          getLoopSubscriptionPrice();

        if (!subscriptionPrice) {
          return;
        }


        // -----------------------------------------------
        // Get Shopify ORIGINAL compare-at price
        // -----------------------------------------------

        const compareAtPrice =
          await getProductCompareAtPrice();

        if (!compareAtPrice) {
          return;
        }


        // -----------------------------------------------
        // Calculate discount
        // -----------------------------------------------

        const discount =
          calculateDiscount(
            compareAtPrice,
            subscriptionPrice
          );

        if (discount === null) {
          return;
        }


        console.log(
          "[Subscription Discount]",
          {
            compareAtPrice: compareAtPrice,
            subscriptionPrice: subscriptionPrice,
            discount: `${discount}%`
          }
        );


        // =================================================
        // UPDATE LOOP COMPARE-AT PRICE
        // =================================================

        const loopComparePrice =
          subscriptionOption.querySelector(
            ".loop-widget-purchase-option-compare-at-price"
          );

        formatPrice(
          loopComparePrice,
          compareAtPrice
        );


        // =================================================
        // UPDATE DESKTOP SUBSCRIPTION LABEL
        // =================================================

        const desktopLabel =
          subscriptionOption.querySelector(
            ".loop-widget-purchase-option-label"
          );

        if (desktopLabel) {

          const newText =
            `subscribe • save ${discount}%`;

          if (
            desktopLabel.textContent.trim() !==
            newText
          ) {

            desktopLabel.textContent =
              newText;
          }
        }


        // =================================================
        // UPDATE DESKTOP DESCRIPTION
        // =================================================

        updateDesktopDescription(
          subscriptionOption,
          discount
        );


        // =================================================
        // UPDATE MOBILE SUBSCRIPTION LABEL
        // =================================================

        document
          .querySelectorAll(
            ".drawer-actions .ghost-btn.subscribe"
          )
          .forEach(function(button) {

            const newText =
              `subscribe • save ${discount}%`;

            if (
              button.textContent.trim() !==
              newText
            ) {

              button.textContent =
                newText;
            }

          });


        // =================================================
        // UPDATE MOBILE DESCRIPTION
        // =================================================

        updateMobileDescription(
          discount
        );

      } finally {

        isUpdating = false;

      }
    }


    // =====================================================
    // WAIT FOR LOOP TO LOAD
    // =====================================================

    let attempts = 0;

    const loopInterval =
      setInterval(function() {

        attempts++;

        const loopContainer =
          document.querySelector(
            ".loop-widget-container"
          );

        const subscriptionOption =
          loopContainer?.querySelector(
            '[data-loop-widget-selling-plan-group]'
          );

        if (!subscriptionOption) {

          // Stop after 10 seconds
          if (attempts >= 40) {

            clearInterval(
              loopInterval
            );

          }

          return;
        }

        clearInterval(
          loopInterval
        );


        // Give Loop a moment to finish
        // rendering its prices
        setTimeout(function() {

          updateSubscriptionDiscount();

        }, 300);

      }, 250);


    // =====================================================
    // WATCH FOR VARIANT CHANGES
    // =====================================================

    let lastVariantId =
      getCurrentVariantId();


    const variantInterval =
      setInterval(function() {

        const currentVariantId =
          getCurrentVariantId();

        if (
          currentVariantId &&
          currentVariantId !== lastVariantId
        ) {

          lastVariantId =
            currentVariantId;


          /*
           * Give Shopify + Loop time to update
           * the subscription price before
           * calculating the new discount.
           */

          setTimeout(function() {

            updateSubscriptionDiscount();

          }, 700);

        }

      }, 500);


    // =====================================================
    // UPDATE WHEN SUBSCRIPTION / ONE-TIME IS CLICKED
    // =====================================================

    document.addEventListener(
      "click",
      function(event) {

        const subscribeButton =
          event.target.closest(
            ".ghost-btn.subscribe"
          );

        const oneTimeButton =
          event.target.closest(
            ".ghost-btn.onetime"
          );


        if (
          subscribeButton ||
          oneTimeButton
        ) {

          setTimeout(function() {

            updateSubscriptionDiscount();

          }, 500);

        }

      }
    );

  }


  // =====================================================
  // DOM READY
  // =====================================================

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      init
    );

  } else {

    init();

  }

})();